import React, { useState, useEffect } from 'react';
import ReferralSearch from './ReferralSearch';
import ReferralMap from './ReferralMap';
import ClinicAddress from './ClinicAddress';
import { useNavigate } from "react-router-dom";
import ReferralList from './ReferralList';

import toBoolean from '../../lib/iprs-react-library/src/util/toBoolean';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';

const Referral = ({ api, tokenContent, brandingInfo }) => {
    const navigate = useNavigate();

    // 0. WR-540: Request is made to make the referral know whether payment card has been used before or not.
    // If payment card has been used before, it will render this component.
    // If payment card has not been used before, it will redirect to the payment component

    const [searchResult, setSearchResult] = useState(null);
    const [postCode, setPostCode] = useState('');
    const [searchAgain, setSearchAgain] = useState(false);

    // 1. Check if clinic has been selected.
    const [selectedClinic, setSelectedClinic] = useState(null);
    const [selectedClinicSlots, setSelectedClinicSlots] = useState(null);

    const [mapViewMode, setMapViewMode] = useState({maponly: false, liststyle: "referral-clinic-list", mapstyle: "referral-clinic-map"});
    const [activeMarker, setActiveMarker] = useState(null);

    const [selectedDirections, selectDirections] = useState(null);

    // 2. Check if search again button is clicked.
    //    If searchAgain is true, it will set selectedClinic to null and
    //    this will swap ClinicAddress to ReferralSearch.
    useEffect(() => {
        if (searchAgain !== false) {
            setSelectedClinic(null);
            setSelectedClinicSlots(null);
            setSearchAgain(false);
            selectDirections(null);
            setActiveMarker(null);            
        }
    }, [searchAgain]);
    

    /* Moved code from Map.jsx */

    // State to hold loader status for "Confirm Your Clinic" button.
    const [isClinicConfirmLoading, setIsClinicConfirmLoading] = useState(false)

    // State to hold error message under the "Confirm Your Clinic" button.
    const [confirmClinicErrorMessage, setConfirmClinicErrorMessage] = useState("")

    // Redirecting to feedback page after making an API call
    const apiMakeReferral = (token, facilityID) => {
        const params = {
            "Token": token,
            "FacilityID": facilityID
        }
        api.transact("MakeReferral", params)
            .then(r => {
                console.log("MakeReferral: ", r);
                const urlForFeedBack = '../feedback/'
                    + '?Token=' + token
                    + '&FacilityID=' + facilityID;
                window.location.replace(urlForFeedBack);
                setIsClinicConfirmLoading(false);
            })
            .catch(error => {
                console.log(error.message);
                setConfirmClinicErrorMessage(error.message);
                setIsClinicConfirmLoading(false);
            });
    }

    // For ticket WR-396, This map component needs to now redirect the user to the payment page
    // and the payment page will call "MakeReferral" api endpoint when payment has been successful.
    // This function will redirect the browser to payment function with the url parameters of token and FacilityID
    // which is needed to call the "MakeReferral" endpoint.
    const redirectToPayment = (token, facilityID, isPaymentCardRequired,FacilityName, Address) => {

        console.log(isPaymentCardRequired);
   
        if (isPaymentCardRequired) {
            // When "isPaymentCardRequired" is false, it means valid card hasn't been found
            // and the browser will be directed to payment page with facility ID.
            setIsClinicConfirmLoading(false);
            const address= encodeURIComponent(JSON.stringify(Address));
            const urlForPayment = '../payment/'
                + '?Token=' + token
                + '&FacilityID=' + facilityID
                + '&FacilityName=' + FacilityName
                + '&Address=' + address
                + '&postcode=' + encodeURIComponent(postCode);
            window.location.replace(urlForPayment);
        } else {
            // When "isPaymentCardRequired" is true, it means valid card has been found
            // and its okay to make "MakeReferral" api request, and then the browser
            // will be directed to the "feedback" page.
             //apiMakeReferral(token, facilityID);
          const addressDetails = encodeURIComponent(JSON.stringify(Address));
          const urlForBookingSummary = '../Bookingsummary/'
                + '?Token=' + api.getToken()
                + '&FacilityID=' + facilityID
                + '&FacilityName=' + FacilityName
                + '&Address=' + addressDetails
                + '&postcode=' + encodeURIComponent(postCode)

            window.location.replace(urlForBookingSummary);
        }
    }

    // When Confirm Clinic is clicked, "IsPaymentCardRequired" api endpoint will be called 
    // with the "caseid" in param.
    const confirmClinicHandler = (facilityID,FacilityName, Address) => {

        /* 
            brandingInfo.PaymentCardRequired flags whether we should
            check if the user has a valid payment card on file.
            In later API, IsPaymentCardRequiredNew will be returned
            which will have done the PaymentCardRequired check for us.
            We are being backward compatible here.
        */
        if (toBoolean(brandingInfo?.PaymentCardRequired, true)) {
            const params = {
                "caseid": tokenContent.CaseID
            }
            api.transact("IsPaymentCardRequired", params)
                .then(r => r.apiResult)
                .then(r => {
                    // backward compatible with earlier API version
                    const isPaymentCardRequired = Object.hasOwn(r, 'IsPaymentCardRequiredNew') ?
                        r.IsPaymentCardRequiredNew : true; // with the old API, we assume that payment is required
                    redirectToPayment(api.getToken(), facilityID, isPaymentCardRequired,FacilityName, Address);
                })
                .catch(e => {
                    console.log(e);
                    setIsClinicConfirmLoading(false)
                })
        } else {
          const addressDetails = encodeURIComponent(JSON.stringify(Address));
          const urlForBookingSummary = '../Bookingsummary/'
                + '?Token=' + api.getToken()
                + '&FacilityID=' + facilityID
                + '&FacilityName=' + FacilityName
                + '&Address=' + addressDetails
                + '&postcode=' + encodeURIComponent(postCode)

            window.location.replace(urlForBookingSummary);
        }
    }


    const confirmClinicSlotsHandler = (facilityID, VenueId,FacilityName,Address) => {
        if (!VenueId) {
        console.warn("No available slots for this clinic");
        return;
    }

        const caseid = tokenContent.CaseID;

        const pcSearch = encodeURIComponent(postCode);
        const addressDetails = encodeURIComponent(JSON.stringify(Address));
        const urlForSlots = `/ClinicsSlotAvailability/?Token=${api.getToken()}&FacilityID=${facilityID}&VenueId=${VenueId}&FacilityName=${FacilityName}&Address=${addressDetails}&caseid=${caseid}&brandingInfo=${brandingInfo}&postcode=${pcSearch}`;
        navigate(urlForSlots);
       
    }
    // This function will be triggered when confirm clinic button is clicked.
    const selectClinic = (e, facilityID,FacilityName, Address) => {
        e.preventDefault();
        setConfirmClinicErrorMessage("");
        setIsClinicConfirmLoading(true);
        confirmClinicHandler(facilityID,FacilityName, Address);
    }
    // This function will be triggered when choose and book button is clicked.
    const selectClinicSlots = (e, facilityID, VenueId, FacilityName, Address) => {
        e.preventDefault();
        if (!VenueId) {
            console.warn("No available slots for this clinic");
            return;
        }

        setConfirmClinicErrorMessage("");
        setIsClinicConfirmLoading(true);
        confirmClinicSlotsHandler(facilityID, VenueId,FacilityName,Address);
    }

    const setMapView = (requestedMapView) => {
        const maponly = requestedMapView ?? !mapViewMode.maponly;

        if(maponly) {            
            setMapViewMode({maponly: true, liststyle: "referral-clinic-list referral-clinic-list-mapview", mapstyle: "referral-clinic-map referral-clinic-map-mapview"});            
        }
        else {
            setMapViewMode({maponly: false, liststyle: "referral-clinic-list", mapstyle: "referral-clinic-map"});
        }
    }

    return (
        <>
            <div style={{
                paddingTop: '55px'
            }}>
                {/* If selectedClinic isn't null, the page should display the selected clinic.
                    Otherwise, it should display the ReferralSearch component.
                */}
                {selectedClinic === null ? <ReferralSearch
                    api={api}
                    setSearchResult={setSearchResult}
                    postCode={postCode}
                    setPostCode={setPostCode}
                    clientID={tokenContent.UserID}
                    brandingInfo={brandingInfo}
                    confirmClinicHandler={confirmClinicHandler}
                /> :
                    <ClinicAddress
                        api={api}
                        selectedClinic={selectedClinic}
                        selectedClinicSlots={selectedClinicSlots}
                        setSearchAgain={setSearchAgain}
                        confirmClinicErrorMessage={confirmClinicErrorMessage}
                    />
                }
                {
                searchResult !== null ? 
                    <div className='referral-clinic-map-toggle' id='referralmaptoggle'>
                        <span onClick={() => setMapView(null)}>View Map</span>
                        <div>
                            <FontAwesomeIcon onClick={() => setMapView(null)} className='referral-clinic-map-toggle-button' icon={ mapViewMode.maponly ? faToggleOn : faToggleOff} />
                        </div>
                    </div> : <></> 
                }
                <div className='referral-clinic-container'>
                    {
                        searchResult ? <ReferralList clinics={searchResult}
                        mapViewMode={mapViewMode}                         
                        selectClinic={selectClinic}
                        selectClinicSlots={selectClinicSlots}
                        setSelectedClinic={setSelectedClinic}
                        setSelectedClinicSlots={setSelectedClinicSlots}
                        activeMarker={activeMarker}
                        selectDirections={selectDirections} /> : <></>
                    }

                    <div className={mapViewMode.mapstyle}>
                        {searchResult ?
                            <ReferralMap
                                api={api}
                                searchAgain={searchAgain}
                                setSelectedClinic={setSelectedClinic}
                                setSelectedClinicSlots={setSelectedClinicSlots}
                                postCode={postCode}
                                searchResult={searchResult}
                                brandingInfo={brandingInfo}
                                setIsClinicConfirmLoading={setIsClinicConfirmLoading}
                                isClinicConfirmLoading={isClinicConfirmLoading}
                                setConfirmClinicErrorMessage={setConfirmClinicErrorMessage}
                                confirmClinicErrorMessage={confirmClinicErrorMessage}
                                confirmClinicHandler={confirmClinicHandler}
                                selectClinic={selectClinic}
                                selectClinicSlots={selectClinicSlots}
                                activeMarker={activeMarker}
                                setActiveMarker={setActiveMarker}
                                selectedDirections={selectedDirections}
                                setMapView={setMapView}
                                mapViewMode={mapViewMode}
                            /> : <></>
                        }
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
        </>
    )
}

export default Referral;